import { Modal } from '@livecontrol/scheduler/components';
import { Event } from '@livecontrol/scheduler/model';
import { DateTime } from 'luxon';
import { useState } from 'react';
import type { ScheduledEvent } from '../../graphql';
import { useStream } from './graphql';
import Phase = Event.Phase;

const sleep = async (milis: number): Promise<number> =>
    new Promise(resolve => {
        setTimeout(resolve, milis);
    });

export const Stream = ({ scheduledEvent }: { scheduledEvent: ScheduledEvent }): React.ReactElement => {
    const [prepareStreamMutate, prepareStream] = useStream('streamSignal');
    const [startMutate, startStream] = useStream('startEvent');
    const [stopMutate, stopStream] = useStream('stopEvent');
    const [forceMutate, forceStream] = useStream('forceStream');
    const [loading, setLoading] = useState(false);
    const prompt = Modal.usePrompt();
    const isLive = scheduledEvent.status === Phase.Live.toString();
    const isUpcoming = !!(scheduledEvent.start_time && DateTime.fromISO(scheduledEvent.start_time) > DateTime.now());

    const handleStart = (): void => {
        prompt.confirm({
            title: 'Start event',
            content: 'Are you sure you want to start the event?',
            onAnswer: async (answer) => {
                if (!answer) {
                    return;
                }

                setLoading(true);
                await prepareStreamMutate({ event: Number(scheduledEvent.id) });

                if (!prepareStream.error) {
                    await sleep(1000 * 30);

                    await startMutate({
                        location: scheduledEvent.location?.id ?? '',
                        event: Number(scheduledEvent.id)
                    });

                    if (!startStream.error) {
                        location.reload();
                    }
                }

                setLoading(false);
            }
        });
    };

    const handleStop = (): void => {
        prompt.confirm({
            title: 'Stop event',
            content: 'Are you sure you want to stop the event?',
            onAnswer: async (answer) => {
                if (!answer) {
                    return;
                }

                await stopMutate({
                    location: scheduledEvent.location?.id ?? '',
                    event: Number(scheduledEvent.id)
                });

                if (!stopStream.error) {
                    location.reload();
                }
            }
        });
    };

    const handleForce = (): void => {
        prompt.confirm({
            title: 'Force event',
            content: 'Are you sure you want to force the event?',
            onAnswer: async (answer) => {
                if (!answer) {
                    return;
                }

                await forceMutate({ eventToLink: Number(scheduledEvent.id) });
            }
        });
    };

    return (
    <div className='d-flex flex-column'>
        <h2 className='font-size-18px'>Stream</h2>

        {/* hide this */}

        <small className='mb-4px'>Link current inbound stream to this event.</small>
        <button type='button' className='btn btn-outline-light mb-12px'
        disabled={forceStream.loading}
        onClick={handleForce}
        >{forceStream.loading && (
            <span>
                <i className='fad fa-spinner-third fa-spin mr-8px' />
            </span>
        )}Force Link Event to Stream</button>

        <small className='mb-4px'>Move Event from Upcoming to Live.</small>
        <button type='button' className='btn btn-outline-light mb-12px'
        disabled={!isUpcoming || loading}
        onClick={handleStart}
        >{loading && (
            <span>
                <i className='fad fa-spinner-third fa-spin mr-8px' />
            </span>
        )}Force Start Event</button>
        <small className='mb-4px'>Move Event from Live to Past Events.</small>
        <button type='button' className='btn btn-outline-light mb-12px'
        disabled={!isLive || stopStream.loading}
        onClick={handleStop}
        >{stopStream.loading && (
            <span>
                <i className='fad fa-spinner-third fa-spin mr-8px' />
            </span>
        )}Move to Past Events</button>

    </div>
    );
};
